import { auditReports } from '@mi-front/api-clients';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Alert, AlertTitle, Box, Button, TextField } from '@mui/material';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { ConfirmationAction } from '../../../../../../../../../../components/ConfirmationAction';

interface Props {
  run: auditReports.AodRun;
  isDisabled: boolean;
  isLoading: boolean;
  executeAction: (promise: Promise<unknown>) => void;
}

export function AcceptRun({ run, isDisabled, isLoading, executeAction }: Props) {
  const { $t } = useIntl();
  const acceptMutation = auditReports.useAcceptAodRunRunActions();
  const [reason, setReason] = useState('');

  const handleAccept = async () => {
    await executeAction(
      acceptMutation.mutateAsync({
        id: run.id,
        data: reason ? { reason } : {},
      }),
    );
  };

  if (!run.canAccept) {
    return null;
  }

  return (
    <Alert severity="success">
      <AlertTitle>
        {$t({
          id: 'audit.aod.actions.acceptRun',
          defaultMessage: 'Aceptar',
        })}
      </AlertTitle>
      <Box display="flex" flexDirection="column" gap={2}>
        <Box>
          {$t({
            id: 'audit.aod.actions.acceptRun.description',
            defaultMessage:
              'Aceptar el resultado del reporte y volver a ejecutar para que sea exportado',
          })}
        </Box>
        <Box>
          <ConfirmationAction
            title={$t({
              id: 'audit.aod.actions.acceptRun',
              defaultMessage: 'Aceptar',
            })}
            message={
              <Box display="flex" flexDirection="column" gap={2}>
                <Box>
                  {$t({
                    id: 'audit.aod.actions.acceptRun.description',
                    defaultMessage:
                      'Aceptar el resultado del reporte y volver a ejecutar para que sea exportado',
                  })}
                </Box>
                <TextField
                  label={$t({
                    id: 'audit.aod.actions.acceptRun.reason',
                    defaultMessage: 'Razón (opcional)',
                  })}
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  fullWidth
                  placeholder={$t({
                    id: 'audit.aod.actions.acceptRun.reason.placeholder',
                    defaultMessage: 'Ingrese una razón opcional para aceptar esta ejecución',
                  })}
                />
              </Box>
            }
            confirmLabel={$t({
              id: 'audit.aod.actions.acceptRun',
              defaultMessage: 'Aceptar',
            })}
            onConfirm={handleAccept}
            onSuccess={() => setReason('')}
          >
            {({ onClick }: { onClick: () => void }) => (
              <Button
                variant="outlined"
                color="success"
                size="small"
                startIcon={<CheckCircleIcon />}
                disabled={isDisabled || !run.id || isLoading}
                loading={isLoading}
                loadingPosition="start"
                onClick={onClick}
              >
                {$t({
                  id: 'audit.aod.actions.acceptRun',
                  defaultMessage: 'Aceptar',
                })}
              </Button>
            )}
          </ConfirmationAction>
        </Box>
      </Box>
    </Alert>
  );
}
